























































































  import { Component, PropSync, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
  import DSelectbox from "@/components/DSelectbox/selectbox.vue";
  import DxSelectBox from 'devextreme-vue/select-box';
  import { Contractor, Tariff, UniversalData } from "@/services/models-service";
  import { HeatCarrier } from '@/services/data/heat_carrier_service';
  import DxContextMenu from 'devextreme-vue/context-menu';
  import { periods } from "@/constants";
  import * as _ from "lodash";
  import { confirm, alert } from "devextreme/ui/dialog";
  import PresetService from '@/services/user_preset_service';

  @Component({
    name: 'RowCard',
    components: {
      DSelectbox,
      DxContextMenu,
      DxSelectBox
    }
  })
  export default class  extends Vue {
    @PropSync('data') public dataList!: any;
    @PropSync('removeList') public removeDataList!: UniversalData[];
    @PropSync('save') public disableSave!: boolean;
    @Prop() public secondaryPortion!: any;
    @Prop() public periods!: any;
    @Prop() public aggPeriods!: any;
    @Prop() public blockId!: string;
    @Prop() public allContractor!: Contractor[];
    @Prop() public currentObject!: number;
    @Prop() public viewTariffs!: Tariff[];
    @Prop() public viewPrices!: Tariff[];
    @Prop({default: () => ([])}) public allSecondaryContractor!: Contractor[];
    @Prop({default: () => ([])}) public allSecondaryTariffs!: Tariff[];
    @Prop() public allHeatCarrier!: HeatCarrier[];
    @Prop() public tariffs!: { [key: string]:  any; };
    @Prop() public secondaryTariffs!: { [key: string]:  any; };
    @Prop() public blockAccept!: any;
    @Prop() public blockAcceptVolume!: boolean;
    @Prop({default: false}) public editingRows!: boolean;
    @Prop({default: false}) public editingTariff!: boolean;
    @Prop() public page!: string;
    public options: any[] = [];
    public months = periods;
    private isLoad: boolean = false;

    public oldTariff: string = '';

    get selectWidth() {
      return 1.5 * PresetService.cardWidth
    }

    get tarifReadOnly() {
      if(this.blockAccept) {
        return true;
      } else {
        return false;
      }
    }

    get volumeReadOnly() {
      if(this.blockAcceptVolume) {
        return true;
      } else {
        return false;
      }
    }

    get cssVars() {
      return {
        '--width': PresetService.cardWidth + 'px'
      }
    }

    async created() {
    }

    public dataSorted: boolean = false; // флаг отвечает за то, когда можно сортировать сортировать данные, а когда нет
    public sortedData: any = {}; // отсортированные данные
    @Watch('dataList', {deep: true})
onDataListChanged(newVal: any) {
  if (newVal[this.periods[0]].length === 0 || _.isEqual(newVal, this.sortedData)) return;
  this.dataList = this.sortAndSyncOrders(newVal);
  this.dataSorted = true;
  this.sortedData = _.cloneDeep(this.dataList)
  // this.sortAndSyncOrders(newVal);
}

    getMatchesRows(secondaryData: any) {
      console.log("datalist", this.dataList[this.periods[0]])
      return this.dataList[this.periods[0]].some((i: any) => {
        return secondaryData.contractor_instance_id === i.contractor_instance_id && secondaryData.tariff_instance_id === i.tariff_instance_id
      })
    }


    

    async mounted() {
      this.options = [
        {text: "Удалить"},
        { text: 'Переместить выше' },
        { text: 'Переместить ниже' }
      ];
      this.isLoad = true;
      if (this.dataList && this.dataList[this.periods[0]]) {
    this.dataList = this.sortAndSyncOrders(this.dataList);
  }
    }

    addContractor() {
      if(this.volumeReadOnly || this.tarifReadOnly) return;
      this.$emit("add_new_data");
    }

    get vgoFilter() {
      if (this.blockId === 'vgo23') {
        let ds = this.allContractor.filter((contr: Contractor) => contr.model_name_eco !== this.currentObject);
        return ds
      } else if (this.blockId === 'vgo' || this.blockId === 'vno') {
        let ds = this.allContractor.filter((contr: Contractor) => contr.internal_turnover === true && contr.model_name_eco !== this.currentObject);
        return ds
      } else {
        let ds = this.allContractor.filter((contr: Contractor) => contr.internal_turnover === false && contr.model_name_eco !== this.currentObject);
        return ds
      }
    }

    itemClick(e: any, data: any) {
  if (!this.editingRows) return;

  const month = this.periods[0];
  const list = this.dataList[month];
  const index = list.indexOf(data);

  if (e.itemData.text === "Удалить") {
    this.removeRowData(data);
  } 
  else if (e.itemData.text === "Переместить выше") {
    if (index <= 0) return; // если первый, выше некуда
    const prev = list[index - 1];
    [prev.c_order, data.c_order] = [data.c_order, prev.c_order]; // обмен
    this.dataList = this.sortAndSyncOrders(this.dataList);
  } 
  else if (e.itemData.text === "Переместить ниже") {
    if (index >= list.length - 1) return; // если последний, ниже некуда
    const next = list[index + 1];
    [next.c_order, data.c_order] = [data.c_order, next.c_order]; // обмен
    this.dataList = this.sortAndSyncOrders(this.dataList);
  }
  this.$emit('onMoveRows')
}

    sortAndSyncOrders(datain: Record<string, any[]>) {
  const newData = _.cloneDeep(datain); // глубокая копия
  const allTarifs = new Map<string, number | null>();

  for (const month in newData) {
    const arr = newData[month];
    arr.forEach(item => {
      const key = `${item.id_tarif}_${item.id_contractor}`;
      if (!allTarifs.has(key)) {
        allTarifs.set(key, item.c_order ?? null);
      }
    });
  }

  const definedOrders = [...allTarifs.values()].filter(v => v != null) as number[];
  const maxOrder = definedOrders.length ? Math.max(...definedOrders) : 0;
  let nextOrder = maxOrder + 1;

  for (const [key, order] of allTarifs.entries()) {
    if (order === null) allTarifs.set(key, nextOrder--);
  }

  for (const month in newData) {
    newData[month].forEach(item => {
      const key = `${item.id_tarif}_${item.id_contractor}`;
      item.c_order = allTarifs.get(key) ?? 0;
    });
    newData[month].sort((a, b) => (b.c_order ?? -Infinity) - (a.c_order ?? -Infinity));
  }
  return newData;
}





    removeRowData(data: any) {
      let index = this.dataList[this.periods[0]].indexOf(data);
      let listPeriods = this.aggPeriods.length > 0 ? this.months.concat(this.aggPeriods) : this.months;
      for(let i = 0; i < listPeriods.length; i++) {
        if (this.dataList[listPeriods[i]][index].id) {
          this.removeDataList.push(this.dataList[listPeriods[i]][index]);
        }
        this.dataList[listPeriods[i]].splice(index, 1);
      }
      this.disableSave = false;
    }

    changeContractor(data:UniversalData) {
      if (this.isLoad) {
        let index = this.dataList[this.periods[0]].indexOf(data);
        for(let i = 0; i < this.months.length; i++) {
          this.dataList[this.months[i]][index].id_contractor = data.id_contractor;
          this.dataList[this.months[i]][index].id_tarif = "";
        }
      }
    }

    checkTariffMatching(data:UniversalData) {
      const currentContractor = this.allContractor.find((c:Contractor) => c.id === data.id_contractor);
      let ds: any[] = [];
      if (currentContractor) {
        if (currentContractor.reg_kind_activity) {
          ds = this.viewTariffs;
        } else {
          ds = this.viewPrices;
        }

        if(this.blockId === 'vendors') {
          if(this.page === 'buy') {
            return ds.filter((t: Tariff) => t.value_group === 'Сторонние поставщики' && t.sign_internal_turnover === null);
          }
        } else if(this.blockId === 'end_user_k') {
          if (this.page === 'sale') {
            return ds.filter((t: Tariff) => t.sign_internal_turnover === null && t.value_group !== 'Сторонние поставщики' && t.value_group !== 'Транспорт' && t.collectors);
          }
        } else if(this.blockId === 'end_user_p') {
          if (this.page === 'sale') {
            return ds.filter((t: Tariff) => t.sign_internal_turnover === null && t.value_group !== 'Сторонние поставщики' && t.value_group !== 'Транспорт' && t.heating_system);
          }
        } else if(this.blockId === 'gvs') {
          if (this.page === 'sale') {
            return ds.filter((t: Tariff) => t.sign_internal_turnover === null && t.value_group !== 'Сторонние поставщики' && t.value_group !== 'Транспорт' && t.heating_system);
          }
        } else if(this.blockId === 'wo_volume') {
          if (this.page === 'sale') {
            return ds.filter((t: Tariff) => t.sign_internal_turnover === null && t.value_group !== 'Сторонние поставщики' && t.value_group !== 'Транспорт' && t.heating_system);
          }
        } else if(this.blockId === 'vendor') {
          if (this.page === "transport_cost") {
            return ds.filter((t: Tariff) => t.sign_internal_turnover === null && t.value_group === 'Транспорт' && t.expenses);
          } else {
            return ds.filter((t: Tariff) => t.sign_internal_turnover === null && t.value_group === 'Транспорт' && t.revenue);
          }          
        } else if(this.blockId === 'vno') {
          return ds.filter((t: Tariff) => t.sign_internal_turnover === 'ВНО');
        } else if(this.blockId === 'vgo') {
          if(this.page === 'buy' || this.page === 'sale') {
            return ds.filter((t: Tariff) => t.sign_internal_turnover === 'ВГО' && t.value_group !== 'Транспорт');
          }
          return ds.filter((t: Tariff) => t.sign_internal_turnover === 'ВГО' && t.value_group === 'Транспорт');
        } else if(this.blockId === 'vgo23') {
          if(this.page === 'buy' || this.page === 'sale') {
            return ds.filter((t: Tariff) => t.value_group !== 'Транспорт' && t.sign_internal_turnover == "ВГО");

          }
          return ds.filter((t: Tariff) => t.value_group === 'Транспорт' && t.sign_internal_turnover == "ВГО");

        } else {
          return ds.filter((t: Tariff) => t.sign_internal_turnover === null && t.value_group !== 'Сторонние поставщики' && t.value_group !== 'Транспорт');
        }
      }
    }

    changeTariff(data:UniversalData) {
      let showChoice = false
      if (this.isLoad) {
        let index = this.dataList[this.periods[0]].indexOf(data);
        for(let i = 0 ; i < this.dataList[this.months[0]].length; i++) {
          if (i === index) continue;         
          if (data.id_contractor === this.dataList[this.months[0]][i].id_contractor && data.id_tarif === this.dataList[this.months[0]][i].id_tarif) {
            this.dataList[this.months[0]][index].id_tarif = "";
            alert('Нельзя создать в рамках одного блока дублирующую пару контрагент - тариф', 'Ошибка');
            return;
          }
        }
        for(let month of this.months) {
            this.dataList[month][index].id_tarif = data.id_tarif;
            if (this.dataList[month][index].vol_te !== 0 || this.dataList[month][index].vol_power !== 0) {
              showChoice = true
            }
          }

        if (showChoice && data.id_tarif) {
          const newTariff = this.tariffs[data.id_tarif];
          // при смене тарифа в строке эмитим индекс строки для запуска пересчета данных
          this.$emit('tarifChanged', index, newTariff.description, this.oldTariff, data.block);
        }
      }
      this.disableSave = false;
    }

    rememberTariff(data:UniversalData) {
      // запоминает предыдущее значение тарифа
      this.oldTariff = data.id_tarif;
    }

    tooltipContractor(data: any) {
      const currentContractor = this.allContractor.find((c:Contractor) => c.id === data.id_contractor);
      if (currentContractor?.name) {
        if (data.id && (data.block === 'vno' || data.block === 'vgo')) {
          const result = currentContractor.name + "\nНельзя редактировать контрагента в записях, которые синхронизированы."
          return result
        } else {
          return currentContractor.name
        }
      }
      return ''
    }

    tooltipTariff(data: any) {
      const newTariff = this.tariffs[data.id_tarif];
      if (newTariff?.description) {
        if (this.tarifReadOnly) {
          const result = newTariff.description + "\nНельзя редактировать тариф в записях, которые акцептированы."
          return result
        } else {
          return newTariff.description
        }
      }
      return ''
    }

    tooltipAddBtn() {
      if (this.volumeReadOnly || this.tarifReadOnly) {       
        return  "Нельзя добавить запись в акцептированный блок."
      } else {
        return  ""
      }
    }


  }
